import Cookies from 'js-cookie'

export const TokenKey = '_s_u_i_d_a'
export const UdKey = 'ud'
export const SdKey = 'sd'

let siteList = ['.motie.com','.laikan.com','.author.laikan.com']

if (process.env.NODE_ENV === 'development') {
	siteList.push('localhost')
	siteList.push('127.0.0.1')
}

export function setSdAndUd(token) {
	siteList.forEach(item => {
		Cookies.set(SdKey, token, {expires: 100, domain: item})
	})

	let uid = token.substr(20)
	siteList.forEach(item => {
		Cookies.set(UdKey, uid, {expires: 100, domain: item})
	})
}

export function getCookieToken() {
	return Cookies.get(SdKey)
}

export function removeCookieToken() {
	siteList.forEach(item => {
		Cookies.remove(SdKey, {domain: item})
	})
}

export function removeCookieUd() {
	siteList.forEach(item => {
		Cookies.remove(UdKey, {domain: item})
	})
}

export function setUserInfo(user) {
	let nickName = user && user.nickName
	siteList.forEach(item => {
		Cookies.set('userInfo', {nickName}, {expires: 100, domain: item})
	})
}



// WEBPACK FOOTER //
// ./src/utils/auth.js